__turbopack_context__.v({
  "allDestinationsButton": "HubDestinationMobileView-module__dWss6W__allDestinationsButton",
  "buttonContent": "HubDestinationMobileView-module__dWss6W__buttonContent",
  "icon": "HubDestinationMobileView-module__dWss6W__icon",
  "image": "HubDestinationMobileView-module__dWss6W__image",
});
